export class APIConstants {
  static NoEmbed = 'https://noembed.com/embed?url=';
  static FetchPolicy = {
    NetworkOnly: 'network-only',
  };
}
